
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainModel extends Model<DomainModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'domain.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'domain.property.name' },
		{ name: 'productPlanId', type: 'guid', languageString: 'domain.property.productPlanId' },
		{ name: 'companyId', type: 'guid', languageString: 'domain.property.companyId' },
		{ name: 'created', type: 'Date', languageString: 'domain.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'domain.property.deleted', isHidden: true },
		{ name: 'metaData', type: 'string', languageString: 'domain.property.metaData' },
		{ name: 'awaitingTaskActionId', type: 'guid', languageString: 'domain.property.awaitingTaskActionId' },
		{ name: 'pendingAuthId', type: 'string', languageString: 'domain.property.pendingAuthId' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public productPlanId?: string;
	public companyId?: string;
	public created?: Date;
	public deleted?: Date;
	public metaData?: string;
	public awaitingTaskActionId?: string;
	public pendingAuthId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.productPlanId = undefined;
		this.companyId = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.metaData = undefined;
		this.awaitingTaskActionId = undefined;
		this.pendingAuthId = undefined;
		
	}
	getProperties(){
		return DomainModel.classProperties;
	}
}

